import { Component, OnDestroy } from "@angular/core";
import { AbstractControl, FormControl, FormGroup } from "@angular/forms";
import { Subscription } from "rxjs";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
import { SuccessMessageService } from "src/app/services/message-provider/success-message.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { Platform } from "@ionic/angular";

@Component({
  selector: "app-manage-notifications",
  templateUrl: "./manage-notifications.component.html",
  styleUrls: ["./manage-notifications.component.scss"],
})
export class ManageNotificationsComponent implements OnDestroy {
  public infoForm: FormGroup;

  public sendEmailUponLogin: AbstractControl;
  public allowPromoSms: AbstractControl;
  public allowPromoEmails: AbstractControl;
  public allowPromoPost: AbstractControl;
  public subscrptions: Subscription[] = [];
  public isIos: boolean = false;
  public error: any = null;

  constructor(
    public authService: AuthenticationService,
    private userSession: UserSessionService,
    public successMessageService: SuccessMessageService,
    public platform:Platform,
  ) {
    this.successMessageService.clearMessage();
    this.subscrptions.push(
      this.userSession.getCustomer().subscribe((customer) => {
        if (customer) {
          const emailUponLogin = customer.sendEmailUponLogin;
          const allowPromoEmailsCheck = customer.allowPromoEmails;
          const allowPromoSmsCheck = customer.allowPromoSms;
          const allowPromoPostCheck = customer.allowPromoPost;

          this.infoForm = new FormGroup({
            sendEmailUponLogin: new FormControl(
              emailUponLogin ? emailUponLogin : false,
            ),
            allowPromoSms: new FormControl(
              allowPromoSmsCheck ? allowPromoSmsCheck : false,
            ),
            allowPromoEmails: new FormControl(
              allowPromoEmailsCheck ? allowPromoEmailsCheck : false,
            ),
            allowPromoPost: new FormControl(
              allowPromoPostCheck ? allowPromoPostCheck : false,
            ),
          });
        }
      }),
    );

    this.userSession.refreshCustomer();
  }
  ngOnInit() {
    this.isIos = this.platform.is("ios");
  }

  public onSubmit() {
    this.subscrptions.push(
      this.authService
        .callUpdatePromotionPreferences(this.infoForm.value)
        .subscribe({
          next: (response: any) => {
            if (response && !!response.result) {
              this.userSession.refreshCustomer();
              this.successMessageService.setMessage(
                "Your account has been updated!",
              );
              this.error = null;
            }
          },
          error: (error) => {
            switch (error.getErrorCode().toUpperCase()) {
              case "BAD_CONTENT":
                error.setErrorMessage(error.getErrorMessage());
                break;
              default:
                error.setErrorMessage(error.getErrorMessage());
                break;
            }
            this.successMessageService.clearMessage(); //SuccessMessage is not yet implemented. Needs to be added later
            this.error = error;
          },
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscrptions.forEach((sub) => {
      sub.unsubscribe();
    });
  }
}
